import { createReducer } from '@reduxjs/toolkit';
import { AccountState, LoginResponse } from './models';

import * as AccountActions from './account.actions';
import gaEvents from '../../shared/analyticsEvents';


const INITIAL_STATE: AccountState = {
  emailId: '',
  isLoggedIn: false,
  isAdmin: false,
  loginErrMsg: null,
  loginLoading: true, // login check gets fired at start up
  loginLoaded: false,
  logoutSuccess: false,
};

const accountReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(AccountActions.accountLoginStart, (state) => {
      return {
        ...state,
        emailId: '',
        isLoggedIn: false,
        isAdmin: false,
        loginLoading: true,
        loginLoaded: false,
        logoutSuccess: false
      };
    })
    .addCase(AccountActions.accountLoginSuccess, (state, action) => {
      const isLoggedIn = !!action.payload.success && !!action.payload.emailId;
      return {
        ...state,
        emailId: isLoggedIn ? action.payload.emailId as string : '',
        isLoggedIn,
        isAdmin: isLoggedIn ? !!action.payload.isAdmin : false,
        loginErrMsg: action.payload.errorMsg,
        loginLoading: false,
        loginLoaded: isLoggedIn,
      };
    })
    .addCase(AccountActions.accountLoginFailure, (state, action) => {
      gaEvents.onGA4UserLoginFail();
      return {
        ...state,
        isLoggedIn: false,
        isAdmin: false,
        loginLoading: false,
        loginLoaded: false,
        loginErrMsg: action.payload
      };
    })
    .addCase(AccountActions.accountLoginCheckStart, (state) => {
      return {
        ...state,
        emailId: '',
        isLoggedIn: false,
        isAdmin: false,
        loginLoading: true,
        loginLoaded: false,
        logoutSuccess: false
      };
    })
    .addCase(AccountActions.accountLoginCheckSuccess, (state, action) => {
      const loginResponse: LoginResponse = action.payload;
      const isLoggedIn = !!loginResponse.success && !!loginResponse.emailId;
      if (isLoggedIn) {
        const {emailId} = loginResponse;
        return {
          ...state,
          emailId: emailId as string,
          loginErrMsg: null,
          isLoggedIn: true,
          isAdmin: !!loginResponse.isAdmin,
          loginLoading: false,
          loginLoaded: true,
          logoutSuccess: false
        };
      } else {
        return {
          ...state,
          isLoggedIn: false,
          isAdmin: false,
          loginLoading: false,
          loginLoaded: false,
          loginErrMsg: loginResponse.errorMsg,
          logoutSuccess: false
        };

      }
    })
    .addCase(AccountActions.accountLoginCheckFailure, (state, action) => {
      const loginErrMsg = typeof action.payload === 'string' && !!action.payload ?
        action.payload :
        null;

      return {
        ...state,
        isLoggedIn: false,
        isAdmin: false,
        loginLoading: false,
        loginLoaded: false,
        loginErrMsg,
        logoutSuccess: false
      };
    })
    .addCase(AccountActions.accountLogoutStart, (state) => {
      return {
        ...state,
        loginLoading: true,
        loginLoaded: false,
        logoutSuccess: false
      };
    })
    .addCase(AccountActions.accountLogoutSuccess, (state, action) => {
      return {
        ...state,
        loginLoading: false,
        loginLoaded: false,
        isLoggedIn: false,
        isAdmin: false,
        emailId: '',
        logoutSuccess: action.payload
      };
    })
    .addCase(AccountActions.accountLogoutFailure, (state, action) => {
      return {
        ...state,
        loginLoading: false,
        loginLoaded: false,
        isLoggedIn: false,
        isAdmin: false,
        emailId: '',
        logoutSuccess: false,
        loginErrMsg: action.payload
      };
    })
    .addCase(AccountActions.accountLogoutSilentlyStart, () => {
      return {
        ...INITIAL_STATE,
        loginLoading: false
      };
    });
});

export default accountReducer;